import React, { Component } from "react";
import classNames from "classnames";
import "./styles/badge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Badge extends Component {
  handleClick_delete = (itemId) => (e) => {
    e.preventDefault();
    this.props.deleteItem(itemId);
  };

  handleClick_label = (itemId) => (e) => {
    e.preventDefault();
    this.props.clickItem(itemId);
  };

  render() {
    const { label, className, itemId, showDelete } = this.props;
    return (
      <div
        className={classNames("badge-item pointer-cursor", className)}
        onClick={this.handleClick_label(itemId)}
      >
        <div className="d-flex flex-row">
          <div>
            <small>{label}</small>
          </div>
          {showDelete && (
            <React.Fragment>
              <div className="badge-separator">|</div>
              <div onClick={this.handleClick_delete(itemId)}>
                <FontAwesomeIcon icon="times" className="fa-sm badge-close" />
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default Badge;
